import { csx } from '@vtex/admin-ui'

const styles = {
  emptyBox: csx({
    border: '$neutral',
    borderRadius: 4,
    padding: '$space-5',
  }),
  content: csx({ gap: '$space-5' }),
  filledBox: csx({ gap: '$space-4', alignSelf: 'normal' }),
  discountContainer: csx({
    color: 'secondary',
    display: 'flex',
    alignItems: 'center',
    gap: '$space-2',
  }),
}

export default styles
